import { useState } from "react";

import { EditRubricModal } from "./EditRubricModal";
import { ExpandedRubricModal } from "./ExpandedRubricModal";
import { GenerateRubricModal } from "./GenerateRubricModal";
import { RatingRubricContent } from "./RatingRubricContent";
import { Column } from "@/components";

import { JobInternalConfig as JobInternalConfigType } from "@/types";

export const PostRubricView = ({
  jobInternalConfig,
}: {
  jobInternalConfig: JobInternalConfigType;
}) => {
  /* React Hooks */
  // useState
  const [isRegenerateOpen, setIsRegenerateOpen] = useState(false);
  const [isEditRubricOpen, setIsEditRubricOpen] = useState(false);
  const [isExpandedOpen, setIsExpandedOpen] = useState(false);

  /* Render */
  const render = () => {
    return (
      <>
        <Column className="gap-4">
          {/* Rating Rubric container */}
          <RatingRubricContent
            jobInternalConfig={jobInternalConfig}
            maxRubricHeight="max-h-[400px]"
            onEditClick={() => {
              setIsEditRubricOpen(true);
            }}
            onExpandClick={() => {
              setIsExpandedOpen(true);
            }}
            onRegenerateClick={() => {
              setIsRegenerateOpen(true);
            }}
          />
        </Column>

        {/* Edit Rubric Modal - For editing the rubric text directly */}
        {isEditRubricOpen && (
          <EditRubricModal
            jobInternalConfig={jobInternalConfig}
            onClose={() => {
              setIsEditRubricOpen(false);
            }}
            onRegenerateClick={() => {
              setIsEditRubricOpen(false);
              setIsRegenerateOpen(true);
            }}
          />
        )}

        {/* Generate Rubric Modal - For regenerating the rubric entirely */}
        {isRegenerateOpen && (
          <GenerateRubricModal
            isRegenerate
            jobInternalConfig={jobInternalConfig}
            onClose={() => {
              setIsRegenerateOpen(false);
            }}
          />
        )}

        {/* Expanded Rubric Modal - Full-size view of the rubric */}
        {isExpandedOpen && (
          <ExpandedRubricModal
            jobInternalConfig={jobInternalConfig}
            onClose={() => {
              setIsExpandedOpen(false);
            }}
            onEditClick={() => {
              setIsExpandedOpen(false);
              setIsEditRubricOpen(true);
            }}
            onRegenerateClick={() => {
              setIsExpandedOpen(false);
              setIsRegenerateOpen(true);
            }}
          />
        )}
      </>
    );
  };

  return render();
};
